/** basic.taskType */
export default {
    type_deleteTips: "Удалить этот тип задачи?",
    type_deleteBtn: "Удалить",
    type_taskTypeName: "Название типа задачи",
    type_rules: "Введите название типа аномалии",
    type_dialognTitle: "Изменить детали задачи",
    type_addTitle: "Новый тип задачи",
    type_addLose: "Не удалось добавить!",

    type_language: "Тип языка",
    type_languagePla: "Выберите тип языка",
    type_languageRule: "Тип языка не может быть пустым",
}

